/* eslint-disable */
import React from 'react'
import moment from 'moment'

import SelectDropdown from '../../components/SelectDropdown'
import ContentHeader from '../../containers/ContentHeader'
import { EkgTable } from '../../containers/Tables'
import PageTab from '../../components/PageTab'
import PageTabs from '../../components/PageTabs'
import { getEkgResultOptions } from '../../constants/recordingMaps'
import {
  getName,
  getPhysicianName,
} from '../../containers/Utilities'
import PrevIcon from 'static/images/icons/chevron-left.svg'
import NextIcon from 'static/images/icons/chevron-right.svg'
import {
  ROUTES,
  CONFIRMED,
  CONFIRMED_OPTION,
  TRIAGE,
  TRIAGE_OPTION,
  ALL_PATIENTS_OPTION,
  DASHBOARD_SIDEBAR_WIDTH,
  HEADER_HEIGHT,
  MIN_BPM_VALUE,
  MAX_BPM_VALUE,
  KARDIA_PRO_START_DATE,
  KARDIA_PRO_END_DATE,
  EKG_REVIEW_PAGE_TABS,
  CONTENT_WIDTH,
  EKG_TABLE_ROW_HEIGHT,
  DATE_OMIT_DAY_FMT,
} from '../../constants'
import styles from './EkgReview.css'
import { needToBustCache, filterIsPhysicianPermission } from '../../store/appReducer'
import SearchResultsLabel from '../../components/Search/SearchResultsLabel'
import { checkRpmFeatureEnabled, checkServiceProviderFeatureEnabled, checkIdtfServiceProviderFeatureEnabled, checkIdtfFeatureEnabled, checkNSRNotificationStatus } from 'configs'
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent'
import EcgLoader from 'legacy/containers/EcgLoader'
import AlertBar from '../../../views/components/Common/AlertBar'
import { ALERT_SEVERITY, OVERRIDE_STYLE, ALERT_MSG } from '../../../views/components/Common/AlertBar/Constants'

class EkgReview extends React.Component {
  state = {
    innerHeight: 0,
    innerWidth: 0,
  }

  UNSAFE_componentWillMount() {
    const {
      dataLastUpdated,
      getEkgReviewData,
    } = this.props

    getEkgReviewData(needToBustCache(dataLastUpdated))

    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  beginningDate = KARDIA_PRO_START_DATE
  today = KARDIA_PRO_END_DATE

  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }

  handleOnInboxClick = () => {
    this.props.handleOnFilterButtonClick(null)
  }

  handleOnTriageEKGNextClick = () => {
    this.props.handleOnEKGNextClick()
  }

  filterPhysicianFromRecordings = recordings => {
    const options = []
    recordings.forEach(r => {
      const patient = r.participantProfile
      if (patient && patient.orderingPhysician) {
        const physician = patient.orderingPhysician
        const opt = {
          id: physician.id,
          label: getName(physician.firstName, physician.lastName, ''),
        }

        if (!options.some(e => e.id === opt.id)) {
          options.push(opt)
        }
      }
    })
    return options
  }

  onEkgTableRowClick = ({ index, rowData }) => {
    this.props.handleOnRowClick({ index, rowData })
  }

  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      handleOnRefreshClick,
      refreshClicked,
      bulkActionComplete,
      bulkActionIsFetching,
      bulkActionSuccessMessage,
      selectedIndex,
      selectedPageTab,
      selectedInboxId,
      selectedEkgResult,
      selectedPatientId,
      selectedPhysicianId,
      selectedPhysicians,
      selectedStartDate,
      selectedEndDate,
      selectedPopover,
      selectedBpmStartValue,
      selectedBpmEndValue,
      selectedConfirmedCurrentMonth,
      selectedEkgs,
      me,
      ekgs,
      ekgStacks,
      ekgStackCounts,
      patients,
      physicians,
      recordingIds,
      sortBy,
      sortDirection,
      handleOnFilterButtonClick,
      handleOnFilterChange,
      handleOnSortClick,
      handleOnTabClick,
      handleOnPhysicianInboxChange,
      handleOnRowClick,
      handleOnBulkAction,
      handleOnBulkActionTriggerModal,
      handleOnBulkActionCloseModal,
      handleOnSelectionClick,
      handleOnConfirmedMonthClick,
      stackNextResultsToken,
      setNSRStatus,
    } = this.props
    const {
      innerHeight,
      innerWidth,
    } = this.state
    let recordings = []

    const NSRNotificationStatus = checkNSRNotificationStatus(me)
    const isIdtfEnabled = checkIdtfFeatureEnabled(me)
    const isIdtfServiceEnabled = checkIdtfServiceProviderFeatureEnabled(me)
    
    let contentHeightRealestate = innerHeight - HEADER_HEIGHT - 11
    const physicianInboxHeight = 51
    switch (selectedPageTab) {
      case EKG_REVIEW_PAGE_TABS.PHYSICIAN:
        contentHeightRealestate -= physicianInboxHeight
        break
      case EKG_REVIEW_PAGE_TABS.CONFIRMED:
        contentHeightRealestate -= physicianInboxHeight
        break
      default:
        break
    }
    const contentWidthRealestate = CONTENT_WIDTH

    let dateRange = [this.beginningDate, this.today]

    let triageCount
    let currentLoggedInPhysicianId
    let physicianCount
    // let confirmedCount

    let selectedInbox
    let inboxOptions = []
    let physicianOptions = []
    const noneOptionItem = {
      id: '0',
      label: '<None>',
    }

    switch (selectedInboxId) {
      case TRIAGE:
        selectedInbox = TRIAGE_OPTION
        break
      case CONFIRMED:
        selectedInbox = CONFIRMED_OPTION
        dateRange = [moment(selectedConfirmedCurrentMonth).startOf('month').toDate(), moment(selectedConfirmedCurrentMonth).endOf('month').toDate()]
        break
      default:
        if (physicians.data) {
          selectedInbox = selectedInboxId && physicians.data.byId[selectedInboxId]
        }
        break
    }

    if (physicians.data) {
      inboxOptions = [...inboxOptions, ...physicians.data.sortedByLastName.map(id => physicians.data.byId[id])]
    }

    if (ekgs.data && !refreshClicked) {
      recordings = recordingIds.map(id => ekgs.data.byId[id])
    }

    if (selectedPageTab === EKG_REVIEW_PAGE_TABS.TRIAGE) {
      if (physicians.data) {
        physicianOptions = [noneOptionItem]
          .concat(filterIsPhysicianPermission(physicians.data.sortedByLastName.map(id => physicians.data.byId[id]))
            .map(p => ({
              id: p.id,
              label: getName(p.firstName, p.lastName, ''),
            })))
      }
    } else if (ekgStacks.data) {
      const selectedInboxRecordIds = ekgStacks.data.stacks[selectedInboxId]
      if (selectedInboxRecordIds
        && selectedInboxRecordIds.sortedByTimestamp
        && selectedInboxRecordIds.sortedByTimestamp.length > 0) {
        const selectedInboxRecords = selectedInboxRecordIds.sortedByTimestamp.map(id => ekgs.data.byId[id])
        physicianOptions = [noneOptionItem].concat(this.filterPhysicianFromRecordings(selectedInboxRecords))
      }
    }

    if (ekgStackCounts.data && me.data) {
      currentLoggedInPhysicianId = me.data.profile.id
      triageCount = ekgStackCounts.data.triage
      physicianCount = ekgStackCounts.data.physicians.byId[currentLoggedInPhysicianId]
      // confirmedCount = ekgStackCounts.data.confirmed
    }

    const hasNoMoreTriageRecords = (stackNextResultsToken && stackNextResultsToken.token === null)
    if (!checkRpmFeatureEnabled(me)) {
      return (
        <div
          data-page="ekg-review"
          className={styles.ekgReview}
        >
          <AccessDeniedContent title="ECG Inbox" />
        </div>
      )
    }

    return (
      <div
        data-page="ekg-review"
        data-value={dataIsFetching ? null : recordings.length}
        className={styles.ekgReview}
      >
        <ContentHeader
          isLoading={dataIsFetching}
          showAddPatient={!me.isFetching}
          showLastRefresh={!me.isFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={handleOnRefreshClick}
          hasTabs
          text="ECG Inbox"
          me={me}
        />

        {me.isFetching
          ? (
            <div
              className={styles.contentWrapper}
            >
              <EcgLoader />
            </div>
          )
          : (
            <React.Fragment>
              <PageTabs>
                <PageTab
                  dataAction="Personal-Inbox"
                  isActive={selectedPageTab === EKG_REVIEW_PAGE_TABS.PHYSICIAN}
                  handleOnClick={() => handleOnTabClick(EKG_REVIEW_PAGE_TABS.PHYSICIAN)}
                  getLabel={physicianCount !== undefined
                    ? () => (
                      <React.Fragment>
                        Personal Inbox
                        <div className={styles.badgeCount}>
                          {physicianCount}
                        </div>
                      </React.Fragment>
                    )
                    : () => 'Personal Inbox'
                  }
                />
                <PageTab
                  dataAction="Practice-Inbox"
                  isActive={selectedPageTab === EKG_REVIEW_PAGE_TABS.TRIAGE}
                  handleOnClick={() => handleOnTabClick(EKG_REVIEW_PAGE_TABS.TRIAGE)}
                  getLabel={triageCount !== undefined
                    ? () => (
                      <React.Fragment>
                        Practice Inbox
                        <div className={styles.badgeCount}>
                          {triageCount}
                        </div>
                      </React.Fragment>
                    )
                    : () => 'Practice Inbox'
                  }
                />
                <PageTab
                  isActive={selectedPageTab === EKG_REVIEW_PAGE_TABS.CONFIRMED}
                  handleOnClick={() => handleOnTabClick(EKG_REVIEW_PAGE_TABS.CONFIRMED)}
                  // getLabel={confirmedCount !== undefined
                  //   ? () => (
                  //     <React.Fragment>
                  //       Archived
                  //       <div className={styles.badgeCount}>
                  //         {confirmedCount}
                  //       </div>
                  //     </React.Fragment>
                  //   )
                  //   : () => 'Archived'
                  // }
                  label="Archived"
                />
              </PageTabs>

              {selectedPageTab === EKG_REVIEW_PAGE_TABS.PHYSICIAN && (
                <React.Fragment>
                  {!NSRNotificationStatus && !isIdtfEnabled && !isIdtfServiceEnabled &&
                    <AlertBar
                      severity={ALERT_SEVERITY.INFO}
                      overrideStyle={OVERRIDE_STYLE.NSR}
                      textMsg={ALERT_MSG.NSR_INFO}
                      onClickClose={()=>setNSRStatus(true)}
                    /> 
                  }
                  <div
                    className={styles.filters}
                    data-page={`ecg-reivew-tab-${selectedPageTab}`}
                    data-action="select-physician"
                  >
                    <SelectDropdown
                      isLoading={physicians.isFetching || ekgs.isFetching || ekgStacks.isFetching}
                      isClearable={false}
                      backspaceRemovesValue={false}
                      value={selectedInbox}
                      onMenuOpen={this.handleOnInboxClick}
                      onChange={handleOnPhysicianInboxChange}
                      options={inboxOptions}
                      placeholder="Provider..."
                      noOptionsMessage="No provider found"
                      getOptionLabel={p => {
                        const optionLabel = getName(p.firstName, p.lastName, '')
                        return optionLabel
                      }}
                      getOptionValue={d => d.id}
                    />
                  </div>
                </React.Fragment>
              )}

              {selectedPageTab === EKG_REVIEW_PAGE_TABS.TRIAGE && triageCount > 1000 &&
                <React.Fragment>
                  {!NSRNotificationStatus && !isIdtfEnabled && !isIdtfServiceEnabled &&
                    <AlertBar
                      severity={ALERT_SEVERITY.INFO}
                      overrideStyle={OVERRIDE_STYLE.NSR}
                      textMsg={ALERT_MSG.NSR_INFO}
                      onClickClose={()=>setNSRStatus(true)}
                    /> 
                  }
                  <div className={styles.resultsHeader}>
                    <SearchResultsLabel
                      totalRecords={triageCount || 0}
                      totalResults={recordings.length}
                      className={styles.resultsHeaderLabel}
                      isLoading={dataIsFetching || ekgStacks.isFetching}
                    />
                    <button
                      onClick={this.handleOnTriageEKGNextClick}
                      className={styles.nextResultsButton}
                      type="button"
                      disabled={triageCount === 0 || dataIsFetching || ekgStacks.isFetching || hasNoMoreTriageRecords}
                    >
                      <span>Next Set</span>
                      <NextIcon />
                    </button>
                  </div>
                  <div className={styles.resultsHeaderNote}>
                    {hasNoMoreTriageRecords && !(dataIsFetching || ekgStacks.isFetching) ? (
                      'No more records to retrieve.'
                    ) : (
                      'You have more than 1000 records. Please use "Next" button to get more records.'
                    )}
                  </div>
                </React.Fragment>
              }

              {/* NSR Alert to show when triageCount < 1000, Fix-KPW-1071 */}
              {selectedPageTab === EKG_REVIEW_PAGE_TABS.TRIAGE && triageCount < 1000 &&
                <React.Fragment>
                  {!NSRNotificationStatus && !isIdtfEnabled && !isIdtfServiceEnabled &&
                    <AlertBar
                      severity={ALERT_SEVERITY.INFO}
                      overrideStyle={OVERRIDE_STYLE.NSR}
                      textMsg={ALERT_MSG.NSR_INFO}
                      onClickClose={() => setNSRStatus(true)}
                    />
                  }
                </React.Fragment>
              }

              {selectedPageTab === EKG_REVIEW_PAGE_TABS.CONFIRMED && (
                <React.Fragment>
                  {!NSRNotificationStatus && !isIdtfEnabled && !isIdtfServiceEnabled &&
                    <AlertBar
                      severity={ALERT_SEVERITY.INFO}
                      overrideStyle={OVERRIDE_STYLE.NSR}
                      textMsg={ALERT_MSG.NSR_INFO}
                      onClickClose={()=>setNSRStatus(true)}
                    /> 
                  }
                  <div
                    className={styles.monthSelection}
                    data-page={`ecg-reivew-tab-${selectedPageTab}`}
                    data-action="select-month"
                  >
                    <button
                      className={styles.prevButton}
                      onClick={() => handleOnConfirmedMonthClick(-1)}
                      disabled={refreshClicked}
                    >
                      <PrevIcon />
                    </button>
                    {/* Not ISO 8601 */}
                    <p className={styles.monthText}>{moment(selectedConfirmedCurrentMonth).format(DATE_OMIT_DAY_FMT)}</p>
                    <button
                      className={styles.nextButton}
                      onClick={() => handleOnConfirmedMonthClick(1)}
                      disabled={moment(selectedConfirmedCurrentMonth).add(1, 'month').startOf('month').isAfter(moment(), 'day') || refreshClicked}
                    >
                      <NextIcon />
                    </button>
                  </div>
                </React.Fragment>
              )}

              <div
                className={styles.tableContent}
                style={{
                  height: contentHeightRealestate,
                  width: contentWidthRealestate,
                }}
                data-page={`ecg-review-table_${selectedPageTab}`}
                data-value={dataIsFetching ? null : recordings.length}
              >
                <EkgTable
                  enableLoader={recordingIds.length === 0 || refreshClicked}
                  showLoader={dataIsFetching || ekgStacks.isFetching}
                  data={recordings}
                  rowHeight={EKG_TABLE_ROW_HEIGHT}
                  showRowSelection={true}
                  selected={selectedEkgs}
                  onSelectionClick={handleOnSelectionClick}
                  height={contentHeightRealestate}
                  width={contentWidthRealestate}
                  onRowClick={this.onEkgTableRowClick}
                  selectedIndex={selectedIndex}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  me={me}
                  filterDate={!moment(selectedStartDate).isSame(dateRange[0], 'day') || !moment(selectedEndDate).isSame(dateRange[1], 'day')}
                  filterPatient={selectedPatientId}
                  filterAnalysis={selectedEkgResult.length > 0}
                  filterAnalysisBy={selectedPhysicianId}
                  filterPhysicians={selectedPhysicians && selectedPhysicians.length > 0}
                  filterBpm={selectedBpmStartValue !== MIN_BPM_VALUE || selectedBpmEndValue !== MAX_BPM_VALUE}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  handleOnFilterChange={handleOnFilterChange}
                  handleOnSortClick={handleOnSortClick}
                  handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
                  handleOnBulkAction={handleOnBulkAction}
                  handleOnBulkActionTriggerModal={handleOnBulkActionTriggerModal}
                  handleOnBulkActionCloseModal={handleOnBulkActionCloseModal}
                  handleOnBulkActionClearSelection={() => handleOnSelectionClick({})}
                  bulkActionComplete={bulkActionComplete}
                  bulkActionIsFetching={bulkActionIsFetching}
                  bulkActionSuccessMessage={bulkActionSuccessMessage}
                  showBulkActionRemove={selectedInboxId !== CONFIRMED}
                  selectedPopover={selectedPopover}
                  showConfirmedDate={selectedInboxId === CONFIRMED}
                  selectedInboxId={selectedInboxId}
                  confirmedMonthDate={moment(selectedConfirmedCurrentMonth)}
                  selectedStartDate={selectedStartDate}
                  selectedEndDate={selectedEndDate}
                  dateRange={dateRange}
                  selectedBpmStartValue={selectedBpmStartValue}
                  selectedBpmEndValue={selectedBpmEndValue}
                  bpmRange={[MIN_BPM_VALUE, MAX_BPM_VALUE]}
                  showPatientColumns
                  patients={patients}
                  selectedPatientId={selectedPatientId}
                  physicians={physicians}
                  selectedPhysicianId={selectedPhysicianId}
                  physicianOptions={physicianOptions}
                  selectedPhysicians={selectedPhysicians}
                  ekgResults={getEkgResultOptions().slice(1)}
                  selectedEkgResult={selectedEkgResult}
                  showOrderingProvider={true}
                />
              </div>
            </React.Fragment>
          )}
        {/* {me.data
          && (
            <Help
              learnMoreIndex={2}
              previousLoginAt={me.data.profile.previousLoginAt}
              lastLoginAt={me.data.profile.lastLoginAt}
            />
          )
        } */}
      </div>
    )
  }
}

export default EkgReview



// WEBPACK FOOTER //
// ./src/legacy/pages/EkgReview/EkgReview.jsx